import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { CATEGORIES, POPULAR_TOOLS, getToolsByCategory } from '../data/tools'
import './Sidebar.css'

function Sidebar({ isOpen, onClose }) {
  const location = useLocation()
  const [expandedCategories, setExpandedCategories] = useState(() =>
    CATEGORIES.map(() => true)
  )

  const toggleCategory = (index) => {
    const newExpanded = [...expandedCategories]
    newExpanded[index] = !newExpanded[index]
    setExpandedCategories(newExpanded)
  }

  const handleLinkClick = () => {
    if (window.innerWidth < 1024) {
      onClose()
    }
  }

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <Link to="/" className="sidebar-logo" onClick={handleLinkClick}>
            <img
              className="sidebar-logo-img"
              src="/logo.svg"
              alt="WebToolz365 — free online tools"
              width="288"
              height="56"
              decoding="async"
            />
          </Link>
          <button className="sidebar-close" onClick={onClose} aria-label="Close menu">
            <span aria-hidden="true">✕</span>
          </button>
        </div>

        <nav className="sidebar-nav">
          {/* Top Tools Section */}
          <div className="sidebar-category">
            <div className="sidebar-category-header" style={{ cursor: 'default' }}>
              <span className="sidebar-category-title">
                <span className="sidebar-category-icon" aria-hidden="true">⭐</span>
                <span>Top Tools</span>
              </span>
            </div>
            <div className="sidebar-category-items">
              {POPULAR_TOOLS.map((tool) => (
                <Link
                  key={tool.slug}
                  to={tool.path}
                  className={`sidebar-item ${location.pathname === tool.path ? 'active' : ''}`}
                  onClick={handleLinkClick}
                >
                  <span className="sidebar-item-icon" aria-hidden="true">{tool.icon}</span>
                  <span className="sidebar-item-name">{tool.shortName}</span>
                </Link>
              ))}
            </div>
          </div>

          {CATEGORIES.map((category, categoryIndex) => (
            <div key={categoryIndex} className="sidebar-category">
              <button
                className="sidebar-category-header"
                onClick={() => toggleCategory(categoryIndex)}
              >
                <span className="sidebar-category-title">
                  <span className="sidebar-category-icon" aria-hidden="true">{category.icon}</span>
                  <span>{category.label}</span>
                </span>
                <span className={`sidebar-category-arrow ${expandedCategories[categoryIndex] ? 'expanded' : ''}`}>
                  ›
                </span>
              </button>

              {expandedCategories[categoryIndex] && (
                <div className="sidebar-category-items">
                  <Link
                    to={`/${category.route}`}
                    className={`sidebar-item sidebar-item-hub ${location.pathname === `/${category.route}` ? 'active' : ''}`}
                    onClick={handleLinkClick}
                  >
                    <span className="sidebar-item-icon" aria-hidden="true">◇</span>
                    <span className="sidebar-item-name">All {category.navTitle} →</span>
                  </Link>
                  {getToolsByCategory(category.id).map((tool) => (
                    <Link
                      key={tool.slug}
                      to={tool.path}
                      className={`sidebar-item ${location.pathname === tool.path ? 'active' : ''}`}
                      onClick={handleLinkClick}
                    >
                      <span className="sidebar-item-icon" aria-hidden="true">{tool.icon}</span>
                      <span className="sidebar-item-name">{tool.shortName}</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <Link
            to="/"
            className={`sidebar-home ${location.pathname === '/' ? 'active' : ''}`}
            onClick={handleLinkClick}
            style={{ marginBottom: '12px' }}
          >
            <span className="sidebar-home-icon">◉</span>
            <span>Home</span>
          </Link>
          <Link
            to="/blog"
            className={`sidebar-home ${location.pathname.startsWith('/blog') ? 'active' : ''}`}
            onClick={handleLinkClick}
            style={{ marginBottom: '12px' }}
          >
            <span className="sidebar-home-icon">✎</span>
            <span>Blog</span>
          </Link>
          <div className="sidebar-version">
            <span className="version-label">WebToolz365</span>
            <span className="version-number">v1.0</span>
          </div>
        </div>
      </aside>
    </>
  )
}

export default Sidebar
